import * as React from 'react';
import { useDispatch } from 'react-redux';
import cls from 'classnames';

import { open, switchMode } from 'src/explore/compositions/Auth/actions';

import styles from './index.module.sass';

export const AuthButtons = ({
  className,
  buttonClassName,
}: {
  className?: string;
  buttonClassName?: string;
}) => {
  const dispatch = useDispatch();

  const handleSignup = () => {
    dispatch( switchMode( 'signup' ));
    dispatch( open());
  };

  const handleLogin = () => {
    dispatch( switchMode( 'login' ));
    dispatch( open());
  };

  return (
    <div className={cls( styles.container, className, 'login--auth-buttons' )}>
      <button
        aria-label="Log In"
        className={cls( buttonClassName, styles.button )}
        type="button"
        onClick={handleLogin}
      >
        Log In
      </button>
      {' | '}
      <button
        aria-label="Sign Up"
        className={cls( buttonClassName, styles.button )}
        type="button"
        onClick={handleSignup}
      >
        Sign Up
      </button>
    </div>
  );
};
